var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddStory22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#2EA7E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8a1 1 0 1 0-2 0l-.212 1.905a1 1 0 0 1-.883.883L8 11a1 1 0 1 0 0 2l1.905.212a1 1 0 0 1 .883.883L11 16a1 1 0 1 0 2 0l.212-1.905a1 1 0 0 1 .883-.883L16 13a1 1 0 1 0 0-2l-1.905-.212a1 1 0 0 1-.883-.883L13 8Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "#000",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStory22);
export default __webpack_public_path__ + "static/media/add_story_22.7dd824b6.svg";
export { ForwardRef as ReactComponent };